import * as React from 'react';

import styles from './index.css';
import { IJsonQueryRangeValue } from '../../../../../api-models/common/json_query';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback } from 'shared/hooks';

export interface IDirectionsModalHeaderProps {
  fromMKAD: IJsonQueryRangeValue;
  label: string;
  onChangeMin(value: number | null): void;
  onChangeMax(value: number | null): void;
}

export const DirectionsModalHeader: React.FC<IDirectionsModalHeaderProps> = ({
  fromMKAD,
  label,
  onChangeMin,
  onChangeMax,
}) => {
  const handleChangeMin = useDebouncedCallback(
    (gte: number | null) => {
      onChangeMin(gte);
    },
    300,
    [onChangeMin],
  );

  const handleChangeMax = useDebouncedCallback(
    (lte: number | null) => {
      onChangeMax(lte);
    },
    300,
    [onChangeMax],
  );

  return (
    <>
      <span className={styles['before']}>{label}</span>
      <div className={styles['inputs']}>
        <RangeInput
          min={1}
          max={9999}
          valueMin={fromMKAD.gte}
          valueMax={fromMKAD.lte}
          onChangeMin={handleChangeMin}
          onChangeMax={handleChangeMax}
          postfix="км"
        />
      </div>
    </>
  );
};
